module.exports = {
    // -- INIT ---
	publicPath: '/',
	// -- END ---
    
    // publicPath: '/',
    css: { extract: false },
    lintOnSave: false,
    devServer: {
        host: 'localhost',
        port: 8080
    }
}